import { isArray } from 'util';
import { parseNumber } from '../../utils/number.utils';
import { UserNotification } from '../user-notification';

export class UserNotificationBuilder {
  static fromJson(json) {
    return (json)
      ? new UserNotification(
        json.hash,
        json.manufacturingOrderNotificationHash,
        json.manufacturingOrderNotificationManufacturingOrderCode,
        json.manufacturingOrderNotificationManufacturingOrderHash,
        json.userHash,
        json.userName,
        json.receiverHash,
        json.receiverName,
        json.comment,
        parseNumber(json.date),
        json.isRead,
        json.isQuantityChanged,
        json.isManufacturingOrderDeliveryDateChangedn
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(UserNotificationBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/user-notification.builder.ts